import React from 'react';
import { Box, BoxProps } from '@mui/material';

import LimitedTypography from 'shared/lib/components/text/limitedTypography';
import IconWarningSign from 'shared/icons/iconWarningSign';

export default function ErrorNotification({
  error,
  ...other
}: BoxProps & { error: string }) {
  return (
    <Box
      {...other}
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        width: 0.7,
        minWidth: 480,
        maxWidth: 570,
        ...other.sx,
      }}
    >
      <Box sx={{ flexShrink: 0 }}>
        <IconWarningSign></IconWarningSign>
      </Box>
      <LimitedTypography
        variant="f14b"
        sx={{
          lineHeight: '14px',
          whiteSpace: 'pre-wrap',
          wordBreak: 'normal',
        }}
        color="error.main"
        clamp={2}
      >
        {error}
      </LimitedTypography>
    </Box>
  );
}
